import type { ReactNode } from "react";
import { cn } from "@/utils";

export function TicketPropertiesGrid({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn("grid grid-cols-[max-content_1fr] items-start gap-x-3 gap-y-3", className)}>{children}</div>;
}

export function TicketPropertiesGridRow({ label, children, action }: { label: string; children: ReactNode; action?: ReactNode }) {
  return (
    <>
      <div className="flex min-h-9 items-center justify-between gap-2">
        <p className="shrink-0 text-xs text-muted-foreground font-medium">{label}</p>
      </div>
      <div className="min-h-9 flex flex-col justify-center gap-1">
        {children}
        {action ? <div className="flex justify-end">{action}</div> : null}
      </div>
    </>
  );
}
